import { adminApiRequest } from "../../utils/apiUtils";

export interface RunnerCompetitionSortRequest {
  id: number;
  displayOrder: number;
}

export const RunnerCompetitionAPI = {
  getRunnerCompetitions: (page?: number): any => {
    return adminApiRequest
      .get(`/runner-competition?page=1&limit=999`)
      .then((res) => res);
  },
  registerRunnerCompetition: (formData: FormData) => {
    return adminApiRequest
      .post("/runner-competition", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);
  },
  updateRunnerCompetition: (id: number, formData: FormData) => {
    return adminApiRequest
      .put(`/runner-competition/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res);
  },
  updateRunnerCompetitionPosterImageSort: (
    id: number,
    request: RunnerCompetitionSortRequest[]
  ) => {
    return adminApiRequest
      .put(`/runner-competition/poster-sort/${id}`, request)
      .then((res) => res);
  },
  updateRunnerCompetitionSponsorImageSort: (
    id: number,
    request: RunnerCompetitionSortRequest[]
  ) => {
    return adminApiRequest
      .put(`/runner-competition/sponsor-sort/${id}`, request)
      .then((res) => res);
  },
  deleteRunnerCompetition: (id: number) => {
    return adminApiRequest
      .delete(`/runner-competition/${id}`)
      .then((res) => res);
  },
  deleteRunnerCompetitionPosterImage: (id: number) => {
    return adminApiRequest
      .delete(`/runner-competition/poster/${id}`)
      .then((res) => res);
  },
  deleteRunnerCompetitionSponsorImage: (id: number) => {
    return adminApiRequest
      .delete(`/runner-competition/sponsor/${id}`)
      .then((res) => res);
  },
};
